
// A list of games in your ActivityFeed
// TODO:  add Date/Timestamp

class ActivityList {

  // let's do a shallow copy for now, we can do a deep copy later:  JSON.parse(JSON.stringify(event));
  static getActivityForPlayer(playerId) {
    let p = (playerId == null) ? 0 : playerId;  // default to 0, which is Tim, the "currentPlayer"
    let result = [];
    this.__list.forEach( (match) => {
      let y = false;
      match.scores.forEach( (player) => {
        //console.log('PLAYER(' + playerId + ')' + JSON.stringify(player));
        if (player.playerId === p) { // 1 == "1" needs to work, so not ===
          y = true;
        }
      })
      if (y) {
        result.push(match);
      }
    });
    return result;
  }

  static getActivityForGame(gameId) {
    let result = [];
    this.__list.forEach( (match) => {
      if (match.gameId === gameId) {
        result.push(match);
      }
    });
    return result;
  }

  static __list = [
    {
      matchId: 0,
      gameId: 1,  // index to GameList, validate via a test

      // might be more than 1 winner in a game, so we put winner at the player level
      scores: [
        {
          playerId: 1,
          score: "29",
          isWinner: true,
        },
        {
          playerId: 0,   // shouldn't this be PlayerId?
          score: "23",
          isWinner: false,
        },
      ],
    },
    {
      matchId: 1,
      gameId: 0,
      scores: [
        {
          playerId: 0,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 1,
          score: "8",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 2,
      gameId: 4,
      scores: [
        {
          playerId: 1,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 2,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 3,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 3,
      gameId: 3,
      scores: [
        {
          playerId: 0,
          score: "1",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "0",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 4,
      gameId: 5,
      scores: [
        {
          playerId: 3,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 2,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 1,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 5,
      gameId: 9,
      scores: [
        {
          playerId: 7,
          score: "11",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 6,
      gameId: 11,
      scores: [
        {
          playerId: 1,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 3,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 7,
      gameId: 12,
      scores: [
        {
          playerId: 0,
          score: "15",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 7,
          score: "6",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 8,
      gameId: 12,
      scores: [
        {
          playerId: 7,
          score: "11",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 9,
      gameId: 12,
      scores: [
        {
          playerId: 7,
          score: "15",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "9",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 10,
      gameId: 12,
      scores: [
        {
          playerId: 4,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 7,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 11,
      gameId: 12,
      scores: [
        {
          playerId: 6,
          score: "12",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 7,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 12,
      gameId: 11,
      scores: [
        {
          playerId: 7,
          score: "25",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "9",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 13,
      gameId: 12,
      scores: [
        {
          playerId: 6,
          score: "32",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 7,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 14,
      gameId: 3,
      scores: [
        {
          playerId: 4,
          score: "1",
          isWinner: true,
        },
        {
          playerId: 0,
          score: "0",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 15,
      gameId: 4,
      scores: [
        {
          playerId: 1,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 2,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 3,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 16,
      gameId: 4,
      scores: [
        {
          playerId: 2,
          score: "12",
          isWinner: true,
        },
        {
          playerId: 1,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 3,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 17,
      gameId: 5,
      scores: [
        {
          playerId: 3,
          score: "0",
          isWinner: true,
        },
        {
          playerId: 1,
          score: "2",
          isWinner: false,
        },
        {
          playerId: 8,
          score: "3",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 18,
      gameId: 3,
      scores: [
        {
          playerId: 0,
          score: "1",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "0",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 19,
      gameId: 4,
      scores: [
        {
          playerId: 1,
          score: "10",
          isWinner: true,
        },
        {
          playerId: 2,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 3,
          score: "6",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 20,
      gameId: 5,
      scores: [
        {
          playerId: 3,
          score: "0",
          isWinner: true,
        },
        {
          playerId: 1,
          score: "1",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "3",
          isWinner: false,
        },
      ]
    },
    {
      matchId: 21,
      gameId: 7,
      scores: [
        {
          playerId: 5,
          score: "12",
          isWinner: true,
        },
        {
          playerId: 4,
          score: "10",
          isWinner: false,
        },
        {
          playerId: 6,
          score: "8",
          isWinner: false,
        },
        {
          playerId: 0,
          score: "5",
          isWinner: false,
        },
      ]
    },

  ];

}
export default ActivityList;



// WEBPACK FOOTER //
// ./src/data/ActivityList.js